import type { SaturationGrade } from '@keywordgod/shared';
import { cn } from '@/lib/utils';

const LEVEL_COLOR: Record<SaturationGrade, string> = {
  매우높음: 'bg-red-500',
  높음: 'bg-amber-500',
  보통: 'bg-blue-500',
  낮음: 'bg-emerald-500',
  매우낮음: 'bg-gold',
};

const LEVEL_TEXT: Record<SaturationGrade, string> = {
  매우높음: 'text-red-400',
  높음: 'text-amber-400',
  보통: 'text-blue-400',
  낮음: 'text-emerald-400',
  매우낮음: 'text-gold',
};

export function SaturationBar({
  value,
  level,
  className,
}: {
  /** 0~100+ 포화도 (%) */
  value: number;
  level: SaturationGrade;
  className?: string;
}) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div className={cn('space-y-2', className)}>
      <div className="flex items-end justify-between">
        <div className="text-xs uppercase tracking-widest text-gray-400">포화지수</div>
        <div className={cn('text-xs font-bold', LEVEL_TEXT[level])}>{level}</div>
      </div>
      <div className="flex items-baseline gap-2">
        <span className="tabular text-3xl font-extrabold text-white">{value.toFixed(1)}</span>
        <span className="text-gray-500">%</span>
      </div>
      <div className="h-2 w-full rounded-full bg-gray-800 overflow-hidden">
        <div
          className={cn('h-full rounded-full transition-[width] duration-700', LEVEL_COLOR[level])}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
